import { COLOR_EVENTS, OBJECT_BACKGROUND_COLOR_REFERENCE } from '../shared.js'

export const cpicker = {
    parts: {
        main: {
            label: 'Main',
            exportSuffix: '',
            order: 0,
            properties: {
                bg_color:    { type: 'color', format: 'hex8' },
                bg_opa:      { type: 'int', min: 0, max: 255, internal: true },
                // Every theme file already sets a bare radius — previously
                // undeclared here, same class of gap as img.js/qrcode.js.
                radius:      { type: 'int', min: 0, max: 999 },
                scale_width: { type: 'int', min: 0 },
                pad_inner:   { type: 'int', min: 0 },
            },
        },
        indicator: {
            label: 'Ring',
            exportSuffix: '10',
            order: 1,
            properties: {
                // radius:       { type: 'int', min: 0, max: 999 },
                border_width: { type: 'int', min: 0 },
                border_color: { type: 'color' },
            },
        },
        knob: {
            label: 'Knob',
            exportSuffix: '20',
            order: 2,
            properties: {
                border_width: { type: 'int', min: 0 },
                border_color: { type: 'color' },
                padding:      { type: 'int', min: 0, exportSpecial: true },
            },
        },
    },

    properties: {
        x: { type: 'int' }, y: { type: 'int' },
        width: { type: 'int', min: 0 }, height: { type: 'int', min: 0 },
        min_width: { type: 'int', min: 0 }, min_height: { type: 'int', min: 0 },
        haspid:   { type: 'int', min: 1, max: 254, internal: true },
        parentid: { type: 'int', min: 0, max: 254, internal: true },
        enabled:      { type: 'bool' },
        color:        { type: 'color' },
        mode:         { type: 'enum', values: ['hue', 'saturation', 'value'] },
        mode_fixed:   { type: 'bool', label: 'Mode fixed' },
        stretch_mode: {
            type: 'string', internal: true, default: 'keep_ratio',
            options: ['none', 'keep_ratio', 'v_stretch', 'h_stretch', 'full'],
        },
    },

    defaults: {
        properties: {
            x: 0, y: 0, width: 100, height: 100, min_width: 20, min_height: 20,
            enabled: true,
            color: '#ff0000',
            mode: 'hue', mode_fixed: false,
        },
        styles: {
            // scale_width: 30 and pad_inner: 20 match lv_theme_hasp.c:705/708.
            // Note HaspColorpicker.js currently has a hardcoded `|| 10`
            // fallback for pad_inner that no longer matches this default —
            // that mismatch is expected; fixing the widget-code fallback is
            // a separate Phase 4 task (rendering bugs), not this schema pass.
            main: { scale_width: 30, pad_inner: 20 },
        },
    },
    states: ['pressed', 'disabled'],
    editorCapabilities:  ['can_transform', 'can_copy', 'has_objectmenu', 'keep_ratio'],
    runtimeCapabilities: ['has_action'],

    events: COLOR_EVENTS,

    bindings: {
        properties: { color: {} },
        actions: { hass_services: ['', 'homeassistant', 'openhasp', 'light', 'esphome'] },
    },

    automation: {
        runtimeVariables: [
            { name: 'color', type: 'color', label: 'Selected Color' },
        ],
        actionHints: {
            light: {
                turn_on: [
                    {
                        parameter: 'rgb_color',
                        value: '[{{ r }},{{ g }},{{ b }}]',
                        label: 'Colorpicker RGB color',
                    },
                    {
                        parameter: 'hs_color',
                        value: '[{{ h }},{{ s }}]',
                        label: 'Colorpicker Hue / Saturation',
                    },
                    {
                        parameter: 'rgb_color',
                        value: OBJECT_BACKGROUND_COLOR_REFERENCE,
                        label: 'Object background color (bg_color)',
                    },
                ],
            },
        },
        preferredDataParameters: {
            'light.turn_on': ['rgb_color', 'hs_color'],
        },
        actionDomains: ['light', 'homeassistant', 'openhasp', 'esphome'],
    },

    // Popup-template widgets bound to an entity (openhasp popup action —
    // see hassPopupUtils.js's generatePopupJsonl) read this HA attribute at
    // export time to reflect the entity's live value.
    templateEntityBinding: { property: 'color', attribute: 'rgb_color' },
}
